export const fmtMs = (ms: number | null | undefined) =>
  ms === null || ms === undefined ? '—' : ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(ms < 10_000 ? 2 : 1)} s`;

export const fmtUsd = (v: number | null | undefined) => {
  if (v === null || v === undefined) return '—';
  if (v === 0) return '$0';
  if (v < 0.01) return `$${v.toFixed(4)}`;
  return `$${v.toFixed(2)}`;
};

export const fmtInt = (n: number | null | undefined) => (n === null || n === undefined ? '—' : n.toLocaleString());

export const fmtWhen = (iso: string | null | undefined) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const fmtDateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : '—';

/** Variables referenced by prompt templates ({{name}}, {{#if name}}), mirroring the SDK's extractVariables. */
export const extractVariables = (template: string): string[] => {
  const names = new Set<string>();
  for (const m of template.matchAll(/\{\{#(?:if|unless)\s+([a-zA-Z_][\w.]*)\s*\}\}/g)) names.add(m[1].split('.')[0]);
  for (const m of template.matchAll(/\{\{\s*([a-zA-Z_][\w.]*)\s*\}\}/g)) names.add(m[1].split('.')[0]);
  return [...names];
};
